import React from "react";

const Ban = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path
            fillRule="evenodd"
            d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M4.9393398,7.0606602 L16.9393398,19.0606602 L19.0606602,16.9393398 L7.0606602,4.9393398 L4.9393398,7.0606602 Z"
            fill="currentColor"
        />
    </svg>
);

export default Ban;
